function l(e, n) {
  for (var t = -1, h = n.length, f = e.length; ++t < h; )
    e[f + t] = n[t];
  return e;
}
export {
  l as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_arrayPush.js
// module id = 862
// module chunks = 41